import { NgModule } from "@angular/core";
import { GotxGridComponent } from "./gotx-grid/gotx-grid.component";
import { JqWidgetsModule } from "../jqWidgets.module";
import { GotxComboBoxComponent } from './gotx-combo-box/gotx-combo-box.component';
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { CommonModule } from "@angular/common";
import { GotxKeyValueListComponent } from './gotx-key-value-list/gotx-key-value-list.component';
import { GotxMarketDepthComponent } from './gotx-market-depth/gotx-market-depth.component';
import { GotxTableComponent } from './gotx-table/gotx-table.component';
import { StockComponent } from "./Stock/Stock.component";
import { GotxGridSimpleComponent } from "./gotx-grid-simple/gotx-grid-simple.component";
import { TxTimePipe } from './TxTime/tx-time.pipe';
import { DecimalFormatterPipe } from "../pipes/decimalFormatter.pipe";
import { GotxChartComponent } from './gotx-chart/gotx-chart.component';
import { GotxMenuComponent } from './gotx-menu/gotx-menu.component';
import { GotxNewsComponent } from './gotx-news/gotx-news.component';
import { FormsModule } from "@angular/forms";
import { RAFormModule } from "src/app/ra-form/ra-form.module";
import { GotxPopupComponent } from "./gotx-popup/gotx-popup.component";
import { GotxMarketWatchEditColumnComponent } from "./gotx-market-watch-edit-column/gotx-market-watch-edit-column.component";
import { change_passwordModule } from "../pages/change_password/change_password.module";
import { HttpLoaderFactory } from "src/app/http-loader-factory";
import { MarketwatchformatterPipe } from "../pipes/marketwatchformatter.pipe";
import { TickerformatterPipe } from "../pipes/tickerformatter.pipe";
import { GotxGridComponentID } from "./gotx-grid-id/gotx-grid-id.component";

@NgModule({
    declarations: [
        GotxGridComponent,
        GotxComboBoxComponent,
        GotxKeyValueListComponent,
        GotxMarketDepthComponent,
        GotxTableComponent,
        GotxGridSimpleComponent,
        GotxChartComponent,
        GotxMenuComponent,
        GotxNewsComponent,
        GotxPopupComponent,
        GotxMarketWatchEditColumnComponent,
        StockComponent,
        DecimalFormatterPipe,
        MarketwatchformatterPipe,
        TxTimePipe,
        TickerformatterPipe,
        GotxGridComponentID,
        ],
    imports: [
        CommonModule,
        FormsModule,
        RAFormModule,
        JqWidgetsModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory, // Moved to Seperate File By Mirsha
                deps: [HttpClient]
            }
        })
    ],
    providers: [],
    exports: [
        CommonModule, 
        FormsModule, 
        RAFormModule, 
        JqWidgetsModule,
        TranslateModule,
        change_passwordModule,
        
        GotxGridComponent,
        GotxComboBoxComponent,
        GotxKeyValueListComponent,
        GotxMarketDepthComponent,
        GotxTableComponent,
        GotxGridSimpleComponent,
        GotxChartComponent,
        GotxMenuComponent,
        GotxNewsComponent,
        GotxPopupComponent,
        GotxMarketWatchEditColumnComponent,
        StockComponent,
        DecimalFormatterPipe,
        MarketwatchformatterPipe,
        TickerformatterPipe,
        GotxGridComponentID,
        
    ]
})
export class GotxComponentsModule { }